import {Flex} from '@mantine/core';
import React from 'react';

import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {QueryingScratchFilePaneContent} from 'pipelines/files/ScratchFilePaneContent';
import {PipelineStepRawData} from 'pipelines/PipelineTypes';
import getTestProps from 'test/lib/cypress/getTestProps';
import Pane from 'ui-library/pane/Pane';

// In pixels, since Mantine converts a numeric height to rem and the root font size is 62.5%.
const REPORT_HEIGHT = '480px';

export interface CustomCodeReportPreviewProps {
  report: PipelineStepRawData<PipelineStepDataKind.FILE>;
}

/**
 * The report of a Custom code step that's a cell script, shown with the step's error when it fails, so the user can
 * see the cells that ran, what they showed, and the one that failed.
 */
export default function CustomCodeReportPreview({report}: CustomCodeReportPreviewProps): JSX.Element {
  return (
    <Flex
      direction="column"
      h={REPORT_HEIGHT}
      {...getTestProps({component: 'CustomCodeReportPreview', element: 'root'})}
    >
      <Pane title="Report">
        <QueryingScratchFilePaneContent fileId={report.id} />
      </Pane>
    </Flex>
  );
}
